import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {
  ApplicationConfig,
  importProvidersFrom,
  provideZonelessChangeDetection
} from '@angular/core';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MAT_TOOLTIP_SCROLL_STRATEGY_FACTORY_PROVIDER } from '@angular/material/tooltip';
import { HAMMER_GESTURE_CONFIG, HammerGestureConfig } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { NoPreloading, provideRouter, withPreloading, withRouterConfig } from '@angular/router';
import { appConfig as fuseAppConfig } from '@core/config/app.config';
import { CoreModule } from '@core/core.module';
import { FuseModule } from '@fuse';
import { FuseConfigModule } from '@fuse/services/config/config.module';
import { LayoutModule } from '@layout/layout.module';
import { provideHotToastConfig } from '@ngxpert/hot-toast';
import { AuthInterceptor } from '@shared/interceptor/auth.interceptor';
import { appRoutes } from './app.routing';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(
      appRoutes,
      withPreloading(NoPreloading),
      withRouterConfig({ onSameUrlNavigation: 'reload' })
    ),
    provideAnimations(),
    provideNativeDateAdapter(),
    provideHttpClient(withInterceptorsFromDi()),
    importProvidersFrom(
      FuseModule,
      FuseConfigModule.forRoot(fuseAppConfig),
      CoreModule,
      LayoutModule
    ),
    provideHotToastConfig({
      position: 'top-center'
    }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    MAT_TOOLTIP_SCROLL_STRATEGY_FACTORY_PROVIDER,
    { provide: HAMMER_GESTURE_CONFIG, useClass: HammerGestureConfig }
  ]
};
